import { formatMoney } from 'Common/functions/Money';
import humanizeMinutes from 'Common/utils/humanizeMinutes';
import { DiscountType } from 'Generated/graphql';

export const formatDiscountValue = (value: number, type: DiscountType) => {
  const isPercent = type === DiscountType.Percent;
  if (isPercent) {
    return `${value}%`;
  }

  const isCappedPercent = type === DiscountType.CappedPercent;
  if (isCappedPercent) {
    return `${value}% up to ${formatMoney(value, true)}`;
  }

  return `${formatMoney(value, true)}`;
};

export const getDiscountRuleDeltaCopy = (
  nextThreshold: {
    progressPercent: number;
    discountRule: {
      requireDurationBookedSeconds: number;
      requireBookingCount: number;
    };
  },
) => {
  if (nextThreshold) {
    const { requireDurationBookedSeconds, requireBookingCount } = nextThreshold.discountRule;
    if (requireDurationBookedSeconds) {
      const remainingSeconds =
        requireDurationBookedSeconds * (1 - nextThreshold.progressPercent / 100);

      // Round the remaining time to the nearest 5 minutes
      const remainingMinutesRounded =
        Math.round(remainingSeconds / 300) * 5; // 300 seconds = 5 minutes
      const timeCopy = humanizeMinutes(remainingMinutesRounded, true);
      return `${timeCopy} more`;
    } else if (requireBookingCount) {
      const remainingBookings =
        Math.ceil(requireBookingCount * (1 - nextThreshold.progressPercent / 100));

      return remainingBookings.toString();
    }
  }
};

